/**
 * 密码处理工具
 */
import md5 from 'md5'

/**
 * 将字符串倒序
 * @param {string} str 要倒序的字符串
 * @returns {string} 倒序后的字符串
 */
export function reverse(str) {
  if (!str) return ''
  return str.split('').reverse().join('')
}

/**
 * 对密码进行MD5加密后倒序
 * @param {string} password 原始密码
 * @returns {string} MD5加密后倒序的密码
 */
export function encryptPassword(password) {
  if (!password) return ''
  // 先进行MD5加密，再倒序
  return reverse(md5(password))
} 

export { md5 }